import React, { useState } from 'react';
import { Button, CircularProgress, TextField } from '@material-ui/core';

function MFA(props) {
  const { classes, onSubmit, onSubmitState, email, password } = props;

  const [token, setToken] = useState('');

  return (
    <div className={classes.input}>
      <TextField
        name="token"
        label="MFA Code or One Time Passcode"
        fullWidth
        variant="outlined"
        autoComplete="one-time-code"
        color="secondary"
        value={token}
        onChange={({ target }) => setToken(target.value)}
      />
      &nbsp;
      <Button
        variant="contained"
        type="submit"
        color="secondary"
        disableElevation
        size="large"
        className={classes.button}
        fullWidth
        onClick={() => onSubmit({ email, password, token })}
        disabled={onSubmitState || !token}
      >
        {onSubmitState && <CircularProgress color="secondary" size={25} thickness={3} />}
        Sign In
      </Button>
    </div>
  );
}

export default MFA;
